import { render, staticRenderFns } from "./BindNew.vue?vue&type=template&id=be0e3f2e&scoped=true&"
import script from "./BindNew.vue?vue&type=script&lang=js&"
export * from "./BindNew.vue?vue&type=script&lang=js&"
import style0 from "./BindNew.vue?vue&type=style&index=0&id=be0e3f2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0e3f2e",
  null
  
)

export default component.exports